module.exports = __webpack_public_path__ + "img/card-btn.22cd80d3.png";